import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Button from '../Button';
import { PHONE_MEDIA_QUERY, useMediaQuery } from '../../common/responsive';
import { useNavigate, useLocation } from 'react-router-dom';
import { useFlag } from '@unleash/proxy-client-react';

const Container = styled.div`
  height: 100px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 80px;
  padding-right: 80px;
  @media ${PHONE_MEDIA_QUERY} {
    padding-left: 15px;
    padding-right: 15px;
  }
`;

const ItemsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
`;

const NavItem = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: ${({ theme, $active }) =>
    $active ? theme.text.title : theme.text.secondary};
  font-size: 16px;
  font-weight: 500;
  @media ${PHONE_MEDIA_QUERY} {
    font-size: 14px;
  }
`;

const RightItemsContainer = styled(ItemsContainer)`
  gap: 16px;
  justify-content: flex-end;
  width: 300px;
`;

const HIDE_LOGIN_ROUTES = ['/survey'];

const Navbar = () => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery(PHONE_MEDIA_QUERY);
  const navigate = useNavigate();
  const location = useLocation();
  const enableSpend = useFlag('enableSpend');

  const shouldShowLoginButton = !HIDE_LOGIN_ROUTES.includes(location.pathname);
  const isAppRoute = location.pathname.startsWith('/app');
  const isSpendActive = location.pathname.startsWith('/app/spend');

  return (
    <>
      <Container>
        <img
          style={{
            width: isMobile ? 150 : 200,
          }}
          src='/logo.webp'
        />
        {isAppRoute && enableSpend && (
          <ItemsContainer>
            <NavItem
              type="button"
              $active={isSpendActive}
              onClick={() => navigate('/app/spend')}
            >
              {t('nav.spend')}
            </NavItem>
          </ItemsContainer>
        )}
        <RightItemsContainer>
          {shouldShowLoginButton && (
            <Button
              onClick={() => {
                navigate('/app/home');
              }}
            >
              {t('nav.startNow')}
            </Button>
          )}
        </RightItemsContainer>
      </Container>
    </>
  );
};

export default Navbar;
